/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const editCampaignImageDataSchema = z.object({
	imageId: z.string().uuid(),
	editRequest: z.string(),
	replaceFeed: z.boolean().optional().default(true),
	replaceStory: z.boolean().optional().default(true),
	replaceWelcomeScreen: z.boolean().optional().default(true),
})

export type EditCampaignImageDataSchema = z.infer<typeof editCampaignImageDataSchema>
